import Button from '@components/Button';
import CtaLayout from '@components/CtaLayout';
import Header from '@components/Header';
import { GiftItemType } from '@models/gift';
import { useFlow } from '@router/stackflow';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { Fragment } from 'react';

import Comment from './components/Comment';
import Complete from './components/Complete';
import GiftOrderInfo from './components/GiftOrderInfo';
import useGiftOrder from './hooks/useGiftOrder';

interface Params {
    orderNo: string;
}

const GiftOrderCompleteActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
  const { orderNo } = params;
  const giftOrder = useGiftOrder(orderNo);
  const { replace, push } = useFlow();
  const onConfirmClick = () => {
    replace('MainActivity', {}, { animate: false });
    push('GiftsActivity', { type: 'MAIN' });
  };
  return (
        <AppScreen preventSwipeBack >
            <CtaLayout header={<Header title='선물하기 완료'
                                       noBackIcon />}
                       noFooterBorder
                       footer={<Button fullWidth
                                       onClick={onConfirmClick}>
                           확인
            </Button>} >
                <Comment/>
                {giftOrder && (
                    <Fragment>
                        <GiftOrderInfo giftOrder={giftOrder} />
                        {giftOrder.detail.giftItem.giftItemType === GiftItemType.CASH && (
                            <Complete response={giftOrder}/>
                        )}
                    </Fragment>
                )}
            </CtaLayout>
        </AppScreen>
  );
};

export default GiftOrderCompleteActivity;
